import React from 'react'

import IconArrowLeft from '@inter/icons/orangeds/LG/arrow-left'
import { AppBar } from '@interco/inter-ui/components/AppBar'

import * as S from './styles'

export type HeaderProps = {
  onBackClick: () => void
  title?: string
}

export const Header = ({ onBackClick, title }: HeaderProps) => (
  <S.Container>
    <AppBar
      leftIcon={
        <S.IconButton
          type="button"
          id="left-buttom"
          onClick={() => {
            onBackClick()
          }}
        >
          <IconArrowLeft width={24} height={24} data-testid="left-icon" />
        </S.IconButton>
      }
    >
      {title}
    </AppBar>
  </S.Container>
)
